export default (name, ...args) => {
  const func = name.split(".").reduce((acc, p) => acc[p], window.Jigsaw);
  return new Promise((resolve, reject) => {
    func(...args, resp => {
      if (resp.isSuccess()) {
        resolve(resp.data);
      } else {
        // add a fallback object if resp.data is undefined to track the error
        reject(resp.data || { reason: "jigsaw error", fn: name });
      }
    });
  });
};
